import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";

// icons (same as original form)
import userIcon from "../../images/icon/user-balck-icon.svg";
import emailIcon from "../../images/icon/sms-balck-icon.svg";
import listIcon from "../../images/icon/list-icon.svg";
import messageIcon from "../../images/icon/messages-icon.svg";
import arrowIcon from "../../images/icon/rotate-arrow-black02.svg";

const HireUsContactForm: React.FC = () => {
  const [form, setForm] = useState({
    contactName: "",
    companyName: "",
    email: "",
    projectName: "",
    message: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({ className: "errorMessage" })
  );

  const changeHandler = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    validator.hideMessages();
  };

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (validator.allValid()) {
      console.log("✅ Hire Us Form Submitted:", form);
      alert("Your request has been sent successfully!");

      setForm({
        contactName: "",
        companyName: "",
        email: "",
        projectName: "",
        message: "",
      });

      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  return (
    <form onSubmit={submitHandler} className="xb-contact-input-form">
      <div className="row mt-none-20">
        {/* Contact Name */}
        <div className="col-lg-6 col-md-6 mt-20">
          <div className="xb-input-field">
            <input
              type="text"
              name="contactName"
              value={form.contactName}
              onChange={changeHandler}
              required
            />
            <label>Contact Name*</label>
            <img src={userIcon} alt="user" />
          </div>
          {validator.message(
            "contact name",
            form.contactName,
            "required|alpha_space"
          )}
        </div>
        <div className="col-lg-6 col-md-6 mt-20">
          <div className="xb-input-field">
            <input
              type="text"
              name="companyName"
              value={form.companyName}
              onChange={changeHandler}
              required
            />
            <label>Company Name*</label>
            <img src={listIcon} alt="Company" />
          </div>
          {validator.message(
            "Company name",
            form.contactName,
            "required|alpha_space"
          )}
        </div>

        {/* Company Name (Optional)
        <div className="col-lg-6 col-md-6 mt-20">
          <div className="xb-input-field">
            <input
              type="text"
              name="companyName"
              value={form.companyName}
              onChange={changeHandler}
            />
            <label>Company Name*</label>
            <img src={listIcon} alt="company" />
          </div>
        </div> */}

        {/* Email */}
        <div className="col-lg-6 col-md-6 mt-20">
          <div className="xb-input-field">
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={changeHandler}
              required
            />
            <label>Email Address*</label>
            <img src={emailIcon} alt="email" />
          </div>
          {validator.message("email", form.email, "required|email")}
        </div>

        {/* Project Name */}
        <div className="col-lg-6 col-md-6 mt-20">
          <div className="xb-input-field">
            <input
              type="text"
              name="projectName"
              value={form.projectName}
              onChange={changeHandler}
              required
            />
            <label>Project Name*</label>
            <img src={listIcon} alt="project" />
          </div>
          {validator.message(
            "project name",
            form.projectName,
            "required"
          )}
        </div>

        {/* Message */}
        <div className="col-lg-12 col-md-12 mt-20">
          <div className="xb-input-field xb-massage-field">
            <textarea
              name="message"
              value={form.message}
              onChange={changeHandler}
              required
            ></textarea>
            <label>Your Message*</label>
            <img src={messageIcon} alt="message" />
          </div>
          {validator.message("message", form.message, "required")}
        </div>
      </div>

      {/* Submit Button */}
      <div className="form-submit-btn mt-35">
        <button type="submit" className="thm-btn form-btn">
          Send Request
          <span className="xb-icon">
            <img src={arrowIcon} alt="arrow" />
            <img src={arrowIcon} alt="arrow" />
          </span>
        </button>
      </div>
    </form>
  );
};

export default HireUsContactForm;
